

























































import Vue from 'vue';
import InvoiceSummaryResourceViewModel from '@/src/services/viewModel/resource/InvoiceSummaryResourceViewModel';
import InvoiceListResourceListResultViewModel from '@/src/services/viewModel/resource/InvoiceListResourceListResultViewModel';

export default Vue.extend({
  auth: true,
  data: () => ({
    isLoading: false,
    responseError: undefined,
    invoiceSummary: new InvoiceSummaryResourceViewModel(),
    invoiceItems: {},
  }),
  computed: {
    tenant() {
      return this.$route.params.tenant;
    },
    workspace() {
      return this.$route.params.workspace;
    },
    columns(): any {
      return [
        { value: this.$t('page.invoice.table.date'), field: 'invoiceDate', format: (created: string) => this.$format.localDate(created) },
        { value: this.$t('page.invoice.table.dueDate'), field: 'dueDate', format: (dueDate: string) => this.$format.localDate(dueDate) },
        { value: this.$t('page.invoice.table.name'), field: 'subject' },
        { value: this.$t('page.invoice.table.amount'), field: 'amountOutstanding', format: (amount : number) => this.$format.currency(amount, this.invoiceSummary.currency as any) },
        { value: this.$t('page.invoice.table.status'), field: 'status', format: (value: any) => this.$tEnum('page.invoice.table.statusEnum', value) },
      ];
    },
  },
  async mounted() {
    this.populateInvoiceSummary();
  },
  methods: {
    navigateBackToOverview() {
      this.$router.push('/syna/memberPortal/invoice');
    },
    payOnline(amount?: number, id? : number) {
      if (id) {
        this.$router.push(`/syna/memberPortal/process/online-payment/${id}?amount=${amount}`);
      } else {
        this.$router.push(`/syna/memberPortal/process/online-payment?amount=${amount}`);
      }
    },
    async populateInvoiceSummary() {
      this.isLoading = true;
      try {
        this.invoiceSummary = await this.$service.api.invoices.getMyInvoiceSummary() as InvoiceSummaryResourceViewModel;
      } catch (error: any) {
        this.responseError = error;
      }
      this.isLoading = false;
    },
    async populateInvoiceList() {
      this.isLoading = true;
      try {
        const invoiceList = await this.$service.api.invoices.getMyInvoices();
        return invoiceList;
      } catch (error: any) {
        this.responseError = error;
      }
      this.isLoading = false;
      return new InvoiceListResourceListResultViewModel().fromDTO({ items: [] });
    },
  },
});
